import Header from "../../components/ui/Header";
import MainContent from "./main_content";
import { NoOrganizationState } from "../../components/NoOrganizationState";
import { useOrganizationStore } from "../../store/useOrganizationStore";
import { useSuperAdmin } from "../../hooks/useSuperAdmin";
import "../../components/ui/Header.css";

function Home() {
  const { organizations } = useOrganizationStore();
  const { isSuperAdmin } = useSuperAdmin();

  const showNoOrgState = organizations.length === 0 && !isSuperAdmin;

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-950 to-black text-white">
      <Header />
      {showNoOrgState ? (
        <main className="pt-20 px-4">
          <NoOrganizationState />
        </main>
      ) : (
        <MainContent />
      )}
    </div>
  );
}

export default Home;
